module.exports = __webpack_public_path__ + "img/4-3.4f36f133.svg";